import SyntheseEntitiesEssaisController from './syntheseentities.essais.controller';

export default {
    bindings: {
        syntheseEntity: '=',
        forGeneration: '=',
        ongletOpen: '='
    },
    template: require('./syntheseentities.essais.html'),
    controller: SyntheseEntitiesEssaisController
};
